if (!customElements.get('fuji-product-shortcuts')) {
  customElements.define(
    'fuji-product-shortcuts',
    class extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.targets = new Map();
      }

      connectedCallback() {
        this.productInfo = this.closest('product-info');
        if (!this.productInfo) return;
        this.addEventListener('click', this.onClick);
        this.observer = new MutationObserver((mutations) => {
          if (mutations.some((mutation) => !this.contains(mutation.target))) this.scheduleSync();
        });
        this.observer.observe(this.productInfo, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['id', 'hidden', 'data-fuji-detail-source'],
        });
        this.sync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('click', this.onClick);
        this.targets.clear();
        this.productInfo = null;
      }

      scheduleSync() {
        if (this.syncPending) return;
        this.syncPending = true;
        queueMicrotask(() => {
          this.syncPending = false;
          if (this.isConnected && this.productInfo) this.sync();
        });
      }

      findDetail(source) {
        return [...this.productInfo.querySelectorAll(`details[data-fuji-detail-source="${source}"]`)].find(
          (detail) =>
            detail.id &&
            detail.closest('product-info') === this.productInfo &&
            !detail.closest('[hidden]') &&
            detail.querySelector('summary')
        );
      }

      sync() {
        this.targets.clear();
        const sizeGuide = this.findDetail('size_guide');
        const description = this.findDetail('description');
        const policies = this.findDetail('policies');

        this.querySelectorAll('[data-fuji-shortcut]').forEach((link) => {
          const isInformation = link.dataset.fujiShortcut === 'information';
          const detail = isInformation ? sizeGuide || description : policies;
          if (!detail) {
            if (!link.hidden) link.hidden = true;
            link.removeAttribute('href');
            link.removeAttribute('aria-controls');
            return;
          }

          const fallback = isInformation
            ? sizeGuide
              ? link.dataset.sizeLabel
              : link.dataset.detailsLabel
            : link.dataset.policyLabel;
          const heading = detail.querySelector('summary').textContent.trim();
          const label = isInformation && !sizeGuide ? fallback : heading || fallback;
          const href = `#${encodeURIComponent(detail.id)}`;
          if (link.textContent !== label) link.textContent = label;
          if (link.getAttribute('href') !== href) link.setAttribute('href', href);
          if (link.getAttribute('aria-controls') !== detail.id) link.setAttribute('aria-controls', detail.id);
          if (link.hidden) link.hidden = false;
          this.targets.set(link, detail);
        });

        const hidden = this.targets.size === 0;
        if (this.hidden !== hidden) this.hidden = hidden;
      }

      onClick(event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest('[data-fuji-shortcut]');
        if (!link || !this.contains(link)) return;
        this.sync();
        const detail = this.targets.get(link);
        if (!detail) return;

        event.preventDefault();
        detail.open = true;
        const summary = detail.querySelector('summary');
        summary.focus({ preventScroll: true });
        const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        summary.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
    }
  );
}
